export const ClientBookingProviders = {
  en: {
    'Select instructor': 'Select instructor',
    'Show all available options': 'Show all available options',
  },
  uk: {
    'Select instructor': 'Оберіть інструктора',
    'Show all available options': 'Показати всі доступні варіанти',
  },
};
